import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-psicologia-perinatal',
  templateUrl: './subpage-psicologia-perinatal.component.html',
  styleUrls: ['./subpage-psicologia-perinatal.component.scss']
})
export class SubpagePsicologiaPerinatalComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
